import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular-ivy";
Sentry.init({
  dsn: "https://9ea309c1d74257203b9c2f6dc25c9e8d@o4506058014326784.ingest.us.sentry.io/4506715073478656",
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: [
        "localhost", 
        "https://acs.innoyantra.com/",
        "https://uat-gda-api.innoyantra.com",
        "https://gda-dev-api.azurewebsites.net/api/v1/iy",
        "https://uat-gda-auth-api.innoyantra.com",
        "https://acspoc1.communication.azure.com"
      ],
    }),
    new Sentry.Replay(),
  ],
  // environment: environment.production ? 'production' : 'development', 
  // beforeSend(event) {
  //   return environment.production ? event : null;
  // },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.9,
  replaysOnErrorSampleRate: 0.9,
});
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
